<template>

  <div 
    v-if="allWidgetsToDisplay.length > 0" 
    ref="packery_container" 
    v-packery="{
      itemSelector: '.packery-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    }"
    @dragItemPositioned="dragItemPositioned"
  >  

    <div class="grid-sizer"></div>

    <resizableContainer 
      v-for="card in allWidgetsToDisplay" 
      :key="card.id"
      :width="card.column_width"
      :cardWidths="cardWidths"
      :cardId="card.id"
      @resize-move="onResizing"
      @resize-end="onResizeDone"
      v-draggabilly="{ handle: '.draggibilly-handle' }"
      v-packery-item 
      class="packery-item"
      :data-card-id="card.id"
    >

      <graph-card 
        v-if="card.card_type === 'GRAPH'" 
        :cardId="card.id" 
        :graph="card.graph" 
        :graphData="card.graph_data" 
        class="draggibilly-handle" 
        @card-delete="deleteCard" 
        @card-edit="editCard" 
        @filter-result="generateGraph"
      />


      <stat-card 
        v-if="card.card_type === 'STAT'" 
        :cardId="card.id" 
        :stats="reformatStatsData(card.stat)" 
        :analytics="card.analytics" 
        class="draggibilly-handle" 
        @card-delete="deleteCard" 
        @card-edit="editCard" 
      />
      
    </resizableContainer>
  </div>

  <div v-else class="m-2 text-center">
    <h6>No Saved Cards to display</h6>
  </div>

</template>

<script>

import resizableContainer from './resizableContainer.vue'
import {packeryEvents} from '@/plugins/vue-packery-plugin'
import graphCard from './graphCard.vue'
import statCard from './statCard.vue'

import { cardSizePositionMixins } from '../mixins/cardSizePositionMixins'

import { deleteDashboardCard } from '@/api/dashboard'

export default {
  name: 'Dashboard-Cards',
  components: {
    resizableContainer,
    graphCard,
    statCard
  },
  props: ['allWidgetsToDisplay', 'cardWidths'],
  mixins: [cardSizePositionMixins],
  data () {
    return {
      cardOrder: []
    }
  },
  watch: {
    allWidgetsToDisplay (new_data) {
      return new_data
    }
  },
  methods: {
    onResizing () {
      packeryEvents.$emit('layout', this.$refs.packery_container)
    },
    onResizeDone (data) {
      //console.log(data)
      const { card_id, final_width } = data
      this.resizeCard(card_id, final_width)
    },
    dragItemPositioned (event) {
      this.cardOrder = event.target.packery.items.map((item, idx) => {
        const card_id = item.element.getAttribute('data-card-id')
        return { id: card_id, order_id: idx }
      })

      //console.log(this.cardOrder)
      this.reorderCards(this.cardOrder)
    },
    reformatStatsData (stats) {
      if (Array.isArray(stats)) {
        return stats[0]
      } else {
        return stats
      }
    },
    async deleteCard (card_id) {
      try {
        const response = await deleteDashboardCard(this.customer_id, { id: card_id })
        if (response.status === 201) {
          this.$emit('widget-delete', card_id)
          this.showSuccessMessage('Success', 'Card Deleted Successfully', 'success')
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    editCard (card_data) {
      this.$emit('widget-edit', card_data)
    },
    generateGraph (card_data) {
      this.$emit('generate-temp-graph', card_data)
    }
  }
}
</script>
<style>
.packery-item.is-dragging,
.packery-item.is-positioning-post-drag {
  z-index: 2;
}

.packery-drop-placeholder {
  outline: 3px dashed #444;
  outline-offset: -6px;
  -webkit-transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
}

.draggibilly-handle {
  cursor: move;
}

.grid-sizer {
  width: 25%;
}

</style>